import React, { useState } from 'react'
import ModalComponent from '../../components/ModalComponent'
import { useDispatch, useSelector } from 'react-redux';
import { openForm } from '../../redux/slice/sitesSlice';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { deleteSites, editSites, postSites } from '../../redux/action/sitesAction';
import AlertComponent from '../../components/AlertComponent';

const FormSites = ({param}) => {
    const { idSites, dataByIdSites,  isOpenFormSites, state } = useSelector( (state) => state.sites );
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const [imagebase, setImageBase] = useState('')

    const initialValues = {
      siteName: idSites === '' ? '' : dataByIdSites.siteName,
      siteAddress: idSites === '' ? '' : dataByIdSites.siteAddress,
      siteLon: idSites === '' ? '' : dataByIdSites.siteLon,
      siteLat: idSites === '' ? '' : dataByIdSites.siteLat,
      image: '',
    }
    const validationSchema = Yup.object().shape({
      siteName: Yup.string().required('Name is required!'),
      siteAddress: Yup.string().required('Address is required!'),
      // siteLon: Yup.string().required('City is required!'),
      // siteLat: Yup.string().required('Description is required!'),
    })

    const handleFormSubmit = async (values) => {
      // console.log(values)
      if (state === 'add') {
        param.data = values
        param.data.image = imagebase
        dispatch(postSites(param))
      } else if (state === 'edit') {
        param.data = values
        param.data.image = imagebase
        param.id = dataByIdSites.siteId
        dispatch(editSites(param))
      } else {
        param.id = dataByIdSites.siteId;
        dispatch(deleteSites(param));
      }
    }
    const convert = (event) => {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const base64Image = e.target.result;
        setImageBase(base64Image.split(';')[1].split(',')[1])// Mengatur nilai field "image"
      };

      reader.readAsDataURL(file);

    }
  
    return state === "delete" ? (
      <AlertComponent
        show={isOpenFormSites}
        close={() => dispatch(openForm({ open: false, state: "close" }))}
        action={() => handleFormSubmit()}
      />
    ) : (
    <ModalComponent
      title={state === 'add' ? 'TAMBAH SITES' : 'EDIT SITES'}
      show={isOpenFormSites}
      close={() => dispatch(openForm({ open: false, type: 'close' }))}
      idForm="sites-form"
    >
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
         {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
          <form onSubmit={handleSubmit} id="sites-form">
            <div className='row align-items-center' style={{color: 'white'}}>
                <div className="form-group row mb-3">
                  <label htmlFor="staticEmail" className="col-sm-2 col-form-label">Name</label>
                    <div className="col-sm-10" style={{ paddingBottom: '10px'}}>
                      <input onChange={handleChange}
                        type="text"
                        name="siteName"
                        id="siteName"
                        className='form-control'
                        value={values.siteName}
                        validation={{ touched: touched.siteName, errors: errors.siteName }}
                        props={{
                          onBlur: handleBlur,
                        }}
                      />
                      {touched.siteName && errors.siteName && <span style={{ color: 'red' }}>{errors.siteName}</span>} 
                    </div>

                    <label htmlFor="staticEmail" className="col-sm-2 col-form-label"> Address </label>
                    <div className="col-sm-10" style={{ paddingBottom: '10px'}}>
                      <input onChange={handleChange}
                        type="text"
                        name="siteAddress"
                        id="siteAddress"
                        className='form-control'
                        value={values.siteAddress}
                        validation={{ touched: touched.siteAddress, errors: errors.siteAddress }}
                        props={{
                          onBlur: handleBlur,
                        }}
                      />
                      {touched.siteAddress && errors.siteAddress && <span style={{ color: 'red' }}>{errors.siteAddress}</span>} 
                    </div>

                    <label htmlFor="staticEmail" className="col-sm-2 col-form-label"> Longitude </label>
                    <div className="col-sm-10" style={{ paddingBottom: '10px'}}>
                      <input onChange={handleChange}
                        type="number"
                        name="siteLon"
                        id="siteLon"
                        className='form-control'
                        value={values.siteLon}
                        validation={''}
                        props={{
                          onBlur: handleBlur,
                        }}
                      />
                      {/* {touched.siteLon && errors.siteLon && <span style={{ color: 'red' }}>{errors.siteLon}</span>}  */}
                    </div>

                    <label htmlFor="staticEmail" className="col-sm-2 col-form-label"> Latitude </label>
                    <div className="col-sm-10" style={{ paddingBottom: '10px'}}>
                      <input onChange={handleChange}
                        type="number"
                        name="siteLat"
                        id="siteLat"
                        className='form-control'
                        value={values.siteLat}
                        validation={''}
                        props={{
                          onBlur: handleBlur,
                        }}
                      />
                      {/* {touched.siteLat && errors.siteLat && <span style={{ color: 'red' }}>{errors.siteLat}</span>}  */}
                    </div>
                    <label htmlFor="staticEmail" className="col-sm-2 col-form-label"> Image </label>
                    <div className="col-sm-10" style={{ paddingBottom: '10px'}}>
                      <input onChange={(e)=>{
                        convert(e)
                      }}
                        type="file"
                        className='form-control'
                      />  
                    </div>
              </div>
            </div>
          </form>
          )}
      </Formik>

    </ModalComponent>
  )
}

export default FormSites